import styled from 'styled-components';

import { theme } from '@styles/theme';

import { Text } from '../text';

export interface RatingBoxProps {
  variant?: 'blue' | 'red' | 'orange' | 'green';
  number: number;
  decimalPlaces?: number;
}

export function RatingBox(props: RatingBoxProps) {
  const { number, variant = 'blue', decimalPlaces = 1 } = props;
  return (
    <Container data-variant={variant}>
      <Text
        text={Math.round(number * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces)}
        font="bold18"
      />
    </Container>
  );
}

const Container = styled.div({
  height: '2.5rem',
  width: '2.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '0.25rem',
  '&[data-variant=blue]': {
    backgroundColor: theme.color.blue10,
    borderColor: theme.color.blue20,
    span: {
      color: theme.color.elementBlue100,
    },
  },
  '&[data-variant=red]': {
    backgroundColor: theme.color.red10,
    borderColor: theme.color.red20,
    span: {
      color: theme.color.red100,
    },
  },
  '&[data-variant=orange]': {
    backgroundColor: theme.color.orange10,
    borderColor: theme.color.orange20,
    span: {
      color: theme.color.orange100,
    },
  },
  '&[data-variant=green]': {
    backgroundColor: theme.color.green5,
    borderColor: theme.color.green20,
    span: {
      color: theme.color.green100,
    },
  },
});
